module.exports = __webpack_public_path__ + "9d9463ddc0338b47ffcb9bf94cb304ef.svg";